import _ from "lodash";

export const entity = {
    name: "Organization",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        "OrganizationAxis",
        {
            path: "fullName",
            fieldPath: ['organizationAxis.translatedName', 'translatedName'],
            f: function () {
                return `${this.organizationAxis?.translatedName} - ${this.translatedName}`
            }
        }
    ],
    filters: [
        {
            name: "byOrganizationAxis",
            path: "organizationAxis",
            object: "OrganizationAxis",
            display: "name",
            translateName: true,
            clearable: true,
            client: true,
            isDefault: false,
            query: function (context) {
                const organizationAxisId = _.get(context.data, "organizationAxis.id")
                return organizationAxisId ? {organizationAxis: new global.ObjectID(organizationAxisId)} : {}
            }
        },
        {
            name: "excludeSelectedOrganizationAxes",
            isDefault: false,
            query: function(context) {
                const selectedOrgs = _.get(context, "data.auditedOrganizations") || []

                const selectedIds = selectedOrgs.map(org => new global.ObjectID(org.id))

                const usedAxisIds = selectedOrgs
                    .filter(org => org.organizationAxis)
                    .map(org => new global.ObjectID(org.organizationAxis.id))

                return usedAxisIds.length > 0
                    ? {
                        $or: [
                            {organizationAxis: {$nin: usedAxisIds}},
                            {_id: {$in: selectedIds}}
                        ]
                    }
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "Organization",
    tKey: "mTitle_organization",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            {path: "organizationAxis", display: "codeName"},
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "organizationAxis", display: "codeName"},
            {path: "code"},
            {path: "name", type: "textarea"}
        ]
    },
    filters: ["byOrganizationAxis"]
}
